import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { I18NService } from '@ebw-monorepo/i18n-translate';
import { LoginService } from '@ebw-monorepo/login';
import { LayerStylesService, MapService } from '@ebw-monorepo/map';
import { EbwModalService } from '@ebw-monorepo/modal';
import { PERMISSION_NAME, PermissionService } from '@ebw-monorepo/utils';
import { API_URLS, ApiUrlService } from 'libs/ng-components/utils/src/lib/services/api-url.service';
import { GeoJSON } from 'ol/format';
import { Circle } from 'ol/geom';
import { fromCircle } from 'ol/geom/Polygon';
import { Observer, Subscription, firstValueFrom } from 'rxjs';
import { MapRequestService } from '../../../../services/map-request.service';
import { IHttpMapGet } from './../../../../interfaces/httpReq.interface';
import { IQueryCond, IQueryCreation, IQueryDataset, IQueryOrder } from './../../../../interfaces/query.interface';
import { Query } from './../../../../models/query.model';
import { DrawingService } from './../../../../services/drawing.service';

export enum OPERATOR {
  AND = 'AND',
  OR = 'OR'
}
export enum ORDER {
  ASC = 'ASC',
  DESC = 'DESC'
}
@Component({
  selector: 'ebw-monorepo-query-form',
  templateUrl: './query-form.component.html',
  styleUrls: ['./query-form.component.scss']
})
export class QueryFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() title: string = 'map.sidebar.query.new_query';
  @Input() dataset: string = 'water';
  // @Input() id: number = null;
  @Input() query: Query = null;
  @Input() advanced: boolean = false;

  public get enumOperator(): typeof OPERATOR {
    return OPERATOR;
  }
  public get enumOrder(): typeof ORDER {
    return ORDER;
  }

  /*flag permesso Visibilità query*/
  flagPermessoVisibilityQuery: boolean = true;
  visibility_value: boolean = true;

  /*valore data modifica da passare */
  date_mod_temp: string = '';

  /**Lista tabelle da dataset */
  queryTableList: IQueryCreation[] = [];
  /**Lista dataset presa da configurazione */
  @Input() datasetList: IQueryDataset[] = [];
  /**Lista di campi mostrati nelle condizioni (sono le colonne della tabella selezionata) */
  fields = [];
  conditions = [
    { label: 'Like', name: 'like', type: 'string' },
    { label: 'Less than', name: '<', type: 'integer double' },
    { label: 'Greater than', name: '>', type: 'integer double' },
    { label: 'Equals', name: '=', type: 'integer double string' },
    // { label: 'Equals', name: '=', type: 'string' },
    { label: 'Within', name: 'within', type: 'geometry' }
  ];
  queryForm = new FormGroup({
    query_name: new FormControl(null, [Validators.required]),
    dataset: new FormControl(null, [Validators.required]),
    table_name: new FormControl(null),
    table_label: new FormControl(null),
    query_script: new FormControl(''),
    asset_query_cond: new FormArray([]),
    asset_query_ord: new FormArray([]),
    visibility: new FormControl(false),
    date_modified: new FormControl(''),
    date_created: new FormControl('')
  });

  /** Lista condizioni (where) */
  listConditions = this.queryForm.get('asset_query_cond') as FormArray;
  /** Lista ordinamento (order by) */
  listOrders = this.queryForm.get('asset_query_ord') as FormArray;
  /**Flag per la gestione dell'inserimento geometria in query avanzata */
  showAdvancedTrail: boolean = false;

  /** array di tutte le subscription da rimuovere nel destroy */
  private subscr: Subscription[] = [];

  constructor(
    private httpSrv: MapRequestService,
    private ebwModal: EbwModalService,
    private i18nSrv: I18NService,
    private drawingToolService: DrawingService,
    private mappaService: MapService,
    private layerStyleService: LayerStylesService,
    private apiUrlService: ApiUrlService,
    private _permissionService: PermissionService
  ) {}

  async ngOnInit() {
    /*Permesso visibilità query*/
    this.flagPermessoVisibilityQuery = this._permissionService.checkPermission(
      PERMISSION_NAME.MAP.SIDEBAR.VISIBILITY_QUERY
    );

    // this.datasetList = this.configSidebar.getDatasetConfiguration();

    this.datasetList = history.state.datasets.filter((el) => el.queryable || typeof el.queryable == 'undefined');

    if (this.query) {
      this.mappaService.clearAllFeaturesFromTemporaryLayer(false);

      let respDataset: any = await firstValueFrom(this.getFromDataset());
      this.queryTableList = respDataset;
      if (this.query.table_name) {
        this.onTableChange(this.query.table_name);
      }

      // cerco nelle condizioni se c'è una condizione spaziale
      const geoCond = this.query.asset_query_cond.find(
        (_) => _.comparison == 'within' && _.field_type == 'geometry' && _['geom']
      );

      if (geoCond) {
        const geometry = geoCond['geom'];
        this._addGeomMapLayer(geometry);
        geoCond.value = geoCond['geom'];
      }

      this.queryForm.patchValue({
        query_name: this.query.query_name,
        dataset: this.query.dataset,
        table_name: this.query.table_name,
        table_label: this.query.table_label,
        query_script: this.query.query_script,
        asset_query_cond: this.query.asset_query_cond,
        asset_query_ord: this.query.asset_query_ord,
        visibility: this.query.context_id ? true : false
      });

      if (this.query) {
        this.date_mod_temp = this.query.date_modified;
      }
      this.date_mod_temp = this.query.date_modified;
    }
    // let data_creato = this.datePipe.transform(new Date(), "dd/MM/yyyy  hh:mm:ss");

    this.setFormArray();
    // this.queryScriptControlHandler();
  }

  ngOnChanges(changes: SimpleChanges) {
    // this.advanced = changes.advanced ? changes.advanced.currentValue : null;
    /** rimuovo le precedenti subscription perchè è stato cambiato il tab quindi c'è una variazione di valore */
    this.subscr.map((s) => s.unsubscribe());
    this.queryScriptControlHandler();
  }

  ngOnDestroy() {
    this.subscr.map((s) => s.unsubscribe());
    this._removeGeoFromMap();
  }
  /** Gestore query avanzate */
  queryScriptControlHandler() {
    if (this.advanced) {
      this.queryForm.get('query_script').setValidators(Validators.required);
      this.queryForm.get('table_name').setValidators([]);
      this.queryForm.get('table_name').setErrors(null);
    } else {
      this.queryForm.get('table_name').setValidators(Validators.required);
      this.queryForm.get('query_script').setValidators([]);
      this.queryForm.get('query_script').setErrors(null);
    }
    this.withinSubscription();
    this.drawingToolSubscription();
  }
  /** Funzione per il cambio operatore della condizione (where)
   * @param value string - può essere AND/OR
   * @param index number - indice dell'elemento a cui accedere nella lista
   */
  changeSelected(value: string, index: number) {
    this.listConditions.controls[index].get('operator').setValue(value);
  }
  //GRUPPO WHERE
  /**Aggiunge una nuova FormGroup nel FormArray asset_query_cond
   * @param conditionObject IQueryCond - è opzionale
   */
  addCondition(conditionObject?: IQueryCond) {
    let index = this.listConditions.length;
    let operatorCond = OPERATOR.AND;
    if (index == 0) {
      operatorCond = null;
    }
    let formGroup = new FormGroup({
      comparison: new FormControl(null, [Validators.required]),
      field: new FormControl(null, [Validators.required]),
      value: new FormControl(null, [Validators.required]),
      operator: new FormControl(operatorCond),
      position: new FormControl(index),
      field_type: new FormControl(null),
      field_label: new FormControl(null)
    });
    if (conditionObject) formGroup.patchValue(conditionObject);
    this.listConditions.push(formGroup);
  }
  /** Rimuove FormGroup nel FormArray asset_query_cond
   * @param index number - indice dell'elemento da rimuovere
   */
  removeCodition(index: number) {
    if (index !== -1) {
      const cond = this.listConditions.at(index).getRawValue();

      if (cond.comparison === 'within') {
        this._removeGeoFromMap();
      }

      this.listConditions.removeAt(index);
    }
  }
  /** Aggiunge il type alla condizione necessario per il salvataggio
   * @param field_name string - il nome della condizione inserita
   * @param index number
   */
  conditionFieldChanged(field_name: string, index: number) {
    let field = this.fields.find((el) => el.name == field_name);
    if (field) {
      if (this.listConditions.controls[index].get('field_type').value == 'geometry') {
        this._removeGeoFromMap();
      }
      this.listConditions.controls[index].get('field_type').setValue(field.type);
      this.listConditions.controls[index].get('field_label').setValue(field.label);
      this.listConditions.controls[index].get('comparison').reset();
      this.listConditions.controls[index].get('value').reset();
    }
  }
  // -- FINE WHERE

  orderFieldChanged(field_name: string, index: number) {
    let field = this.fields.find((el) => el.name == field_name);
    if (field) {
      this.listOrders.controls[index].get('field_label').setValue(field.label);
    }
  }

  /** Funzione che, partendo dal dataset, mi recupera la lista di tabelle da mostrate nella form */
  getFromDataset(dataset?: string, subscribe: boolean = false) {
    if (dataset) {
      this.dataset = dataset;
    }
    let req: IHttpMapGet = {
      url: this.apiUrlService.createUrl(API_URLS.MAP.QUERY.CREATION) + '?dataset=' + this.dataset,
      user_id: sessionStorage.getItem(LoginService.USER_ID_KEY)
    };

    let observableRequest = this.httpSrv.getMapRequest(req);
    if (!subscribe) {
      return observableRequest;
    }
    //faccio la subscribe nel caso in cui la funzione viene chiamata dall'html, subscribe = true
    observableRequest.subscribe({
      next: (resp: any) => {
        this.queryTableList = resp;
      },
      error: (error) => {
        console.log('Error QueryComponent - getFromDataset:', error);
      }
    });
    return null;
  }
  /** Fuzione che mi recupera, dopo aver selezionato la tabella, la lista di fields da mostrare nelle condizioni */
  onTableChange(table_name: string) {
    //QUESTO FILTRO PUO' ESSERE SPOSTATO IN UNA PIPE IN FUTURO.
    let table = this.queryTableList.find((el) => el.name == table_name);
    this.queryForm.get('table_label').setValue(table.label);

    if (table.fields) {
      this.fields = table.fields;
    } else {
      let req: IHttpMapGet = {
        url:
          this.apiUrlService.createUrl(API_URLS.MAP.QUERY.CREATION) +
          '?dataset=' +
          this.dataset +
          '&table=' +
          table_name,
        user_id: sessionStorage.getItem(LoginService.USER_ID_KEY)
      };

      let observableRequest = this.httpSrv.getMapRequest(req);
      //faccio la subscribe nel caso in cui la funzione viene chiamata dall'html, subscribe = true
      observableRequest.subscribe({
        next: (resp: any) => {
          this.fields = resp;
        },
        error: (error) => {
          console.log(error);
        }
      });
    }

    /** prendo la posizione registrata nella form per pulire i campi precedenti */
    let raws = (this.queryForm.get('asset_query_cond') as FormArray).getRawValue();
    raws.forEach((r) => {
      if (r.position != 0) {
        this.removeCodition(r.position);
      }
    });
    this.queryForm.get('asset_query_cond').reset();
  }
  //GRUPPO ORDER BY
  /** Aggiunge una nuova FormGroup nel FormArray asset_query_cond */
  addOrder(orderObject?: IQueryOrder) {
    let index = this.listOrders.length;
    let formGroup = new FormGroup({
      field: new FormControl(null, [Validators.required]),
      value: new FormControl('ascending'),
      position: new FormControl(index),
      field_label: new FormControl()
    });
    if (orderObject) formGroup.patchValue(orderObject);
    this.listOrders.push(formGroup);
  }
  /** Funzione per il cambio ordinamento
   * @param value string - può essere ASC/DESC
   * @param index number - indice dell'elemento a cui accedere nella lista
   */
  changeOrder(order: string, index: number) {
    this.listOrders.controls[index].get('value').setValue(order);
  }

  removeOrder(index: number) {
    if (index !== -1) {
      this.listOrders.removeAt(index);
    }
  }
  // -- FINE ORDER BY
  /** Funzione che inizializza le FormArray in modifica */
  setFormArray() {
    //let data_mod = this.datePipe.transform(new Date(), "dd/MM/yyyy  hh:mm:ss");
    //let data_creato = this.datePipe.transform(new Date(), "dd/MM/yyyy  hh:mm:ss");

    if (this.query) {
      this.query.asset_query_cond.forEach((cond) => {
        this.addCondition(cond);
      });
      this.query.asset_query_ord.forEach((ord) => {
        this.addOrder(ord);
      });
    }
  }

  getGeometryOnMap() {
    // rimuovo la geometry prima del drawing tool
    // this._removeGeoFromMap();

    this.drawingToolService.openDrawingTool({
      point: false,
      line: false,
      polygon: true,
      circle: true,
      text: false
    });
  }

  removeGeometry() {
    this.listConditions.clear();
    this._removeGeoFromMap();
  }
  /** Funzione per la gestione della geometria  */
  drawingToolSubscription() {
    const subTool = this.drawingToolService.drawingGeometry$.subscribe({
      next: (feature) => {
        this._removeGeoFromMap();

        let format = new GeoJSON({
          dataProjection: MapService.EPSG_3857_KEY,
          featureProjection: MapService.EPSG_3857_KEY
        });

        let geometry;

        if (feature.getGeometry().getType() === 'Circle') {
          geometry = fromCircle(<Circle>feature.getGeometry());
          geometry = format.writeGeometryObject(geometry);
        } else {
          geometry = format.writeGeometryObject(feature.getGeometry());
        }

        geometry['crs'] = {
          type: 'name',
          properties: {
            name: 'EPSG:3857'
          }
        };

        if (this.advanced) {
          /** prima svuoto la lista per evitare che ne vengano inserite più geometrie. Può essere salvata solo una geometria per query*/
          this.listConditions.clear();
          let cond: IQueryCond = {
            operator: null,
            position: 0,
            comparison: 'within',
            field_type: 'geometry',
            field: 'route',
            value: geometry
          };
          this.addCondition(cond);
        } else {
          let index = this.listConditions.controls.map((m) => m.value).findIndex((c: any) => c.comparison == 'within');
          this.listConditions.controls[index].get('value').setValue(geometry);
        }

        this._addGeomMapLayer(geometry);

        this.drawingToolService.closeDrawingTool();
      },
      error: (error) => {
        console.error('[QueryForm][drawingToolSubscription]', error);
      }
    });
    this.subscr.push(subTool);
  }
  /** Funzione per la gestione della condizione within in listConditions  */
  withinSubscription() {
    /** variabili inizializzate con query standard */
    let observable = this.listConditions.valueChanges;
    let callback: Observer<any> = {
      next: (val: any[] = []) => {
        let length = val.filter((v) => v.comparison == 'within').length;
        if (length > 1) {
          let lastIndex = val.map((v) => v.comparison).lastIndexOf('within');
          this.listConditions.controls[lastIndex].get('comparison').setValue(null);
          this.ebwModal.openWarningModal({
            title: this.i18nSrv.getInstantValue('common.warning'),
            content: this.i18nSrv.getInstantValue('map.sidebar.query.warning_within')
          });
        }
      },
      error: (err) => {
        console.error('[QueryForm][withinSubscription1] ', err);
      },
      complete: () => {}
    };
    /**caso in cui la query è avanzata */
    if (this.advanced) {
      observable = this.queryForm.get('query_script').valueChanges;
      callback = {
        next: (val: string) => {
          if (val && val.indexOf('within trail') >= 0) {
            this.showAdvancedTrail = true;
          } else {
            this.showAdvancedTrail = false;
            this.listConditions.clear();
          }
        },
        error: (err) => {
          console.error('[QueryForm][withinSubscription2] ', err);
        },
        complete: () => {}
      };
    }

    const sub = observable.subscribe(callback);
    this.subscr.push(sub);
  }

  switchVisibility() {
    this.queryForm.controls.visibility.setValue(!this.queryForm.controls.visibility.getRawValue());
  }

  private _addGeomMapLayer(geometry) {
    const geoFeatureStyle = this.layerStyleService.buildFeatureStyleFromId('AcdaFill');

    this.mappaService.centerMapOnGeometry(geometry, false);
    this.mappaService.addFeatureToTemporaryLayer(geometry, geoFeatureStyle, true, false, 'update_query_geom');
  }

  private _removeGeoFromMap() {
    this.mappaService.clearFeatureFromTemporaryLayerById('update_query_geom', true);
  }
}
